import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Chip,
  debounce,
  Dialog,
  DialogActions,
  DialogContent,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  Input,
  InputAdornment,
  InputLabel,
  Link,
  MenuItem,
  Paper,
  Radio,
  RadioGroup,
  Select,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import "./AssignSkills.scss";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useState, KeyboardEvent, useMemo, useContext } from "react";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import AddIcon from "@mui/icons-material/Add";
import { useLocation, useNavigate } from "react-router-dom";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import { visuallyHidden } from "@mui/utils";
import { Breadcrumb } from "../../../../../breadcrumb/components/Breadcrumb";
import { UserListModel } from "../../../../../new-workflow-creation/models/AssignWorkflowModel";
import { useAPI } from "../../../../../../shared/services/api/API";
import {
  tableSorting,
  updateURLParams,
} from "../../../../../../shared/utils/Utils";
import { OPTIVAL_CONSTANTS } from "../../../../../../shared/Constants";
import { DownloadExcelButton } from "../../../../../../shared/components/Download/DownloadExcelButton";
import { TableHeadCell } from "../../../../../../shared/models/TableModels";
import { TableLoading } from "../../../../../../shared/components/skeleton/table-loading/TableLoading";
import { useTranslation } from "react-i18next";
import { useMapAndAssignUtils } from "../../../../models/SkillsConstants";
import {
  EmployeeWithoutSkill,
  EmployeeWithSkill,
  SkillsToEmployee,
  SortObj,
} from "./models/SkillsToEmployee";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { SkillsContext } from "../../../../contexts/SkillsContext";
import { dummySkillsLevels } from "../../../../models/SkillsData";

export const AssignSkills = () => {
  const { updateValidateLessMore } = useContext(SkillsContext);
  const navigate = useNavigate();
  const { httpGet, httpPost, handleAlertBar, httpDelete } = useAPI();
  const [searchText, setSearchText] = useState("");
  const [isLoadingUnAssign, setIsLoadingUnAssign] = useState(false);
  const [unAssignpage, setUnAssignPage] = useState(0);
  const [unAssignedUsers, setUnAssignedUsers] = useState<SkillsToEmployee[]>(
    []
  );
  const [unAssignGroupRowsPerPage, setUnAssignGroupRowsPerPage] = useState(5);
  const [unAssignedGroupUsers, setUnAssignedGroupUsers] = useState<SkillsToEmployee[]>(
    []
  );
  const [displayUnAssignedGroupUsers, setDisplayUnAssignedGroupUsers] = useState<
    SkillsToEmployee[]
  >([]);
  const [checkedUnassignGroup, setCheckedUnassignGroup] = useState<
  SkillsToEmployee[]
  >([]);
  const [searchUserName, setSearchUserName] = useState<string>("");
  const [isUserSearching, setIsUserSearching] = useState(false);
  const [assignedUsers, setAssignedUsers] = useState<SkillsToEmployee[]>([]);
  const [assignedGroupUsers, setAssignedGroupUsers] = useState<SkillsToEmployee[]>([]);
  const [groupList, setGroupList] = useState([]);
  const [groupId, setGroupId] = useState('');
  const [isLoadingAssign, setIsLoadingAssign] = useState(true);
  const [assignPage, setAssignPage] = useState(0);
  const [assignRowsPerPage, setAssignRowsPerPage] = useState(5);
  const [assignGroupPage, setAssignGroupPage] = useState(0);
  const [assignGroupRowsPerPage, setAssignGroupRowsPerPage] = useState(5);
  const [displayAssignedUsers, setDisplayAssignedUsers] = useState<
    SkillsToEmployee[]
  >([]);
  const [displayAssignedGroupUsers, setDisplayAssignedGroupUsers] = useState<
    SkillsToEmployee[]
  >([]);
  const [selectedTab, setSelectedTab] = useState('USER');
  const [unAssignSort, setUnAssignSort] = useState<SortObj>({
    order: "desc",
    orderBy: "name",
  });
  const [assignSort, setAssignSort] = useState<SortObj>({
    order: "desc",
    orderBy: "name",
  });
  const [skillsLevel, setSkillsLevel] = useState([]);
  const [skillsValidation, setSkillsValidation] = useState([
    { id: 1, name: "VALIDATED", label: "Validated" },
    { id: 2, name: "NOTVALIDATED", label: "Not Validated" },
  ]);
  const [selectedSkill, setSelectedSkill] = useState<any>(null);
  const [selectedSkillValidation, setSelectedSkillValidation] =
    useState<any>(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [assignData, setAssignData] = useState<SkillsToEmployee | null>();
  const { state } = useLocation();
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [errorMsg, setErrorMsg] = useState("");
  const excelHeader = [
    "Skill Name*",
    "Skill Level*",
    "Email address*",
    "Validated*",
  ];
  const excelListOptions = ["Beginner", "Intermediate", "Advanced", "Expert"];
  const validatedExcelListOptions = [true, false];
  const defaultValues = {
    A: state.skillName,
    B: "Beginner",
  };

  const { t } = useTranslation();
  const { getAssignWorkflowHeaders, getUnAssignWorkflowHeaders } = useMapAndAssignUtils();

  const handleUploadBoxDragOver = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
  };
  const handleUploadBoxDrop = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    const dropFiles = e.dataTransfer.files[0];
    if (dropFiles.type.includes("sheet")) {
      setSelectedFile(dropFiles);
      setErrorMsg("");
    } else {
      setErrorMsg("Please Upload an excel sheet");
      setSelectedFile(null);
    }
  };

  const handleFileChange: React.ChangeEventHandler<HTMLInputElement> = (
    event
  ) => {
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      setSelectedFile(file);
    }
    event.target.value = "";
  };

  const handleRemoveClick = () => {
    setSelectedFile(null);
  };

  const handleRemoveAssignUser = () => {
    setAssignData(null);
    getUnAssignedSkillsToEmployee("");
  };

  const handleRemoveUnAssignUser = (id: number) => {
    const remainselectedUnassignUser = checkedUnassignGroup?.filter((user) => user?.id !== id);
    setCheckedUnassignGroup(remainselectedUnassignUser);
  }

  const handleUnassignFieldChange = (rowIndex: number, field: string, value: string) => {
    const newData: any = [...unAssignedGroupUsers];
    newData[rowIndex][field] = value;
    const updatedArray = checkedUnassignGroup.map(item2 => {
      const replacement = newData.find((item1: any) => item1.id === item2.id);
      return replacement || item2;
    });
    setCheckedUnassignGroup(updatedArray);
    setUnAssignedGroupUsers(newData);
  };

  const handleBulkUser = async () => {
    const urlParams = {
      skillId: state.skillId,
    };
    const formData = new FormData();
    if (selectedFile) {
      formData.append("file", selectedFile);
    }
    await httpPost(
      updateURLParams(
        OPTIVAL_CONSTANTS.API_URLS.ASSIGN_BULK_SKILL_EMPLOYEES,
        urlParams
      ),
      formData
    ).then(
      (response) => {
        if (response && response.data) {
          if (response.data.error) {
            handleAlertBar(
              "error",
              t(`opva.${response?.data?.code}`) || t("opva.serviceUnavailable")
            );
          } else {
            handleAlertBar("success", t("opva.skillsAssignedSuccessfullyMsg"));
            setSelectedFile(null);
            getAssingedSkillsToEmployee();
          }
        } else {
          handleAlertBar("error", t("opva.serviceUnavailable"));
        }
      },
      (error) => {}
    );
  };

  const backToSkillz = () => {
    navigate("/skillz");
    updateValidateLessMore(true);
  };

  const handleSearchKeyEnter = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter" && searchText.length > 3) {
      getAssingedSkillsToEmployee();
    }
  };

  const handleChangePageForAssigned = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setAssignPage(newPage);
    const startIndex = newPage * assignRowsPerPage;
    setDisplayAssignedUsers([
      ...assignedUsers.slice(startIndex, startIndex + assignRowsPerPage),
    ]);
  };

  const handleChangeRowsPerPageForAssigned = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setAssignRowsPerPage(parseInt(event.target.value, 10));
    setAssignPage(0);
    setDisplayAssignedUsers(
      assignedUsers.slice(0, parseInt(event.target.value, 10))
    );
  };

  const handleChangePageForUnAssignedGroup = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setUnAssignPage(newPage);
    const startIndex = newPage * unAssignGroupRowsPerPage;
    setDisplayUnAssignedGroupUsers([
      ...unAssignedGroupUsers.slice(startIndex, startIndex + unAssignGroupRowsPerPage),
    ]);
  };

  const handleChangeRowsPerPageForUnAssignedGroup = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setUnAssignGroupRowsPerPage(parseInt(event.target.value, 10));
    setUnAssignPage(0);
    setDisplayUnAssignedGroupUsers(
      unAssignedGroupUsers.slice(0, parseInt(event.target.value, 10))
    );
  };

  const handleChangePageForAssignedGroup = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setAssignGroupPage(newPage);
    const startIndex = newPage * assignGroupRowsPerPage;
    setDisplayAssignedGroupUsers([
      ...assignedGroupUsers.slice(startIndex, startIndex + assignGroupRowsPerPage),
    ]);
  };

  const handleChangeRowsPerPageForAssignedGroup = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setAssignGroupRowsPerPage(parseInt(event.target.value, 10));
    setAssignGroupPage(0);
    setDisplayAssignedGroupUsers(
      assignedGroupUsers.slice(0, parseInt(event.target.value, 10))
    );
  };

  const handleSorting = (property: string, table: string) => {
    if (table === "unAssignTable") {
      const isAsc =
        unAssignSort.orderBy === property && unAssignSort.order === "asc";
      setUnAssignSort({ order: isAsc ? "desc" : "asc", orderBy: property });
    } else if (table === "assignTable") {
      const isAsc =
        assignSort.orderBy === property && assignSort.order === "asc";
      setAssignSort({ order: isAsc ? "desc" : "asc", orderBy: property });
    }
  };

  const handleEmptyPage = (data: any, table: string) => {
    if (table === "assignedUser") {
      const sliceArr = data.slice(
        assignPage * assignRowsPerPage,
        assignPage * assignRowsPerPage + assignRowsPerPage
      );
      if (!sliceArr.length) {
        setAssignPage(assignPage === 0 ? 0 : assignPage - 1);
      }
    }
  };

  const handleEmptyPageGroup = (data: any, table: string) => {
    if (table === "assignedGroupUser") {
      const sliceArr = data.slice(
        assignGroupPage * assignGroupRowsPerPage,
        assignGroupPage * assignGroupRowsPerPage + assignGroupRowsPerPage
      );
      if (!sliceArr.length) {
        setAssignPage(assignGroupPage === 0 ? 0 : assignGroupPage - 1);
      }
    } else if (table === "unAssignedGroupUser") {
      const sliceArr = data.slice(
        unAssignpage * unAssignGroupRowsPerPage,
        unAssignpage * unAssignGroupRowsPerPage + unAssignGroupRowsPerPage
      );
      if (!sliceArr.length) {
        setUnAssignPage(unAssignpage === 0 ? 0 : unAssignpage - 1);
      }
    }
  };

  const queryParams = {
    page: 0,
    size: 1000,
    sortColumn: "modifiedAt",
    isDescending: true,
    searchString: searchText,
  };
  const getUnAssignedSkillsToEmployee = useMemo(
    () =>
      debounce((searchUser: string, assignedUserList?: any) => {
        const orgId = localStorage.getItem("organizationId");
        setIsUserSearching(true);
        const urlParams = {
          organizationId: orgId,
        };
        const queryParams = {
          page: 0,
          size: 1000,
          sortColumn: "mail",
          isDescending: true,
          searchString: searchUser,
        };
        httpGet(
          updateURLParams(
            OPTIVAL_CONSTANTS.API_URLS.GET_EMPLOYEES_BY_ORGANISATION,
            urlParams
          ),
          queryParams,
          false
        ).then(
          (response: any) => {
            setIsUserSearching(false);
            if (response && response.data && !response.data?.error) {
              const data = assignedUserList ? assignedUserList : assignedUsers;
              const employees = response.data
                .filter((item: any) => !data?.some((emp: EmployeeWithoutSkill) => emp.employee?.id === item?.id));
              setUnAssignedUsers(employees);
            } else {
              handleAlertBar(
                "error",
                response?.data?.message || t("opva.serviceUnavailable")
              );
            }
          },
          (error: any) => {
            setIsUserSearching(false);
            handleAlertBar(
              "error",
              error.message || t("opva.serviceUnavailable")
            );
          }
        );
      }, 500),
    [assignedUsers]
  );

  const getAssingedSkillsToEmployee = async () => {
    setIsLoadingAssign(true);
    const urlParams = {
      skillId: state.skillId,
      //skillId: 23,
    };
    await httpGet(
      updateURLParams(
        OPTIVAL_CONSTANTS.API_URLS.GET_USER_ASSIGNED_FOR_SKILL,
        urlParams
      ),
      queryParams
    ).then(
      (response: any) => {
        if (response && response.data) {
          if (response.data.error) {
            handleAlertBar(
              "error",
              response?.data?.message || t("opva.serviceUnavailable")
            );
            setIsLoadingAssign(false);
          } else {
            setAssignedUsers(response.data);
            setDisplayAssignedUsers(response.data.slice(0, assignRowsPerPage));
            setIsLoadingAssign(false);
            handleEmptyPage(response.data, "assignedUser");
            getUnAssignedSkillsToEmployee("", response.data);
          }
        } else {
          handleAlertBar("error", t("opva.serviceUnavailable"));
          setIsLoadingAssign(false);
        }
      },
      (error: any) => {
        setIsLoadingAssign(false);
      }
    );
  };

  const getGroups = async () => {
    await httpGet(
      OPTIVAL_CONSTANTS.API_URLS.GET_GROUPS,
      queryParams
    ).then(
      (response: any) => {
        if (response && response.data) {
          if (response.data.error) {
            handleAlertBar(
              "error",
              response?.data?.message || t("opva.serviceUnavailable")
            );
          } else {
            setGroupId('');
            setGroupList(response.data);
          }
        } else {
          handleAlertBar("error", t("opva.serviceUnavailable"));
        }
      },
      (error: any) => {
        setIsLoadingAssign(false);
      }
    );
  };

  const handleGroupChange = (e: any) => {
    setGroupId(e.target.value);
    getUnAssingedSkillsToGroup(e.target.value);
    getAssingedSkillsToGroupEmployee(e.target.value);
    setCheckedUnassignGroup([]);
  }

  const getUnAssingedSkillsToGroup = async (groupId: string) => {
    setIsLoadingUnAssign(true);
    const urlParams = {
      skillId: state.skillId,
      groupId: groupId,
    };
    const queryParams = {
      page: 0,
      size: 1000,
      sortColumn: "modifiedAt",
      isDescending: true,
      searchString: searchText,
      skillId: state.skillId,
      groupId: groupId,
    };
    await httpGet(
      updateURLParams(
        OPTIVAL_CONSTANTS.API_URLS.GET_UNASSIGNED_USER_GROUP_FOR_SKILL,
        urlParams
      ),
      queryParams
    ).then(
      (response: any) => {
        if (response && response.data) {
          if (response.data.error) {
            handleAlertBar(
              "error",
              response?.data?.message || t("opva.serviceUnavailable")
            );
            setIsLoadingUnAssign(false);
          } else {
            setSelectedSkill({
              "id": 1,
              "name": "Beginner",
              "description": "Beginner level skill"
          },);
            setSelectedSkillValidation({ id: 2, name: "NOTVALIDATED", label: "Non Validate" });
            const updateResponse = response?.data?.map((user: any)=> {
              user.validationStatus = user.validationStatus ? 1 : 2;
              user['skillLevelId'] = 1;
              return user
            })
            setUnAssignedGroupUsers(updateResponse);
            setDisplayUnAssignedGroupUsers(updateResponse.slice(0, unAssignGroupRowsPerPage));
            setIsLoadingUnAssign(false);
            handleEmptyPageGroup(updateResponse, "unAssignedGroupUser");
          }
        } else {
          handleAlertBar("error", t("opva.serviceUnavailable"));
          setIsLoadingUnAssign(false);
        }
      },
      (error: any) => {
        setIsLoadingUnAssign(false);
      }
    );
  };

  function allUnassignGroupUserChecked() {
    if (
      unAssignedGroupUsers.length === 0 
      && checkedUnassignGroup.length === 0
    )
      return false;
    for (let user of unAssignedGroupUsers) {
      const isPresent = checkedUnassignGroup.some(
        (data: any) => data.id === user.id
      );

      if (!isPresent) {
        return false;
      }
    }
    return true;
  }

  const handleAllCheckBoxForUnassignGroupUser = (event: any) => {
    if (event.target.checked) {
      const uniqueUser: SkillsToEmployee[] = [];
      unAssignedGroupUsers.forEach((user: SkillsToEmployee) => {
        const index = checkedUnassignGroup.findIndex(
          (checkedUser: SkillsToEmployee) =>
            checkedUser.id === user.id
        );
        if (index === -1) {
          uniqueUser.push(user);
        }
      });
      setCheckedUnassignGroup([
        ...checkedUnassignGroup,
        ...uniqueUser,
      ]);
    } else {
      setCheckedUnassignGroup([]);
    }
  };

  const checkedUnassignedGroupUser = (data: any): boolean => {
    if (!checkedUnassignGroup.length) {
      return false;
    }
    const arr = checkedUnassignGroup.filter(
      (res: any) => res.id === data.id
    );
    return arr.length > 0 ? true : false;
  };

  const handleCheckBoxForGroupUser = (event: any, data: any) => {
    if (event.target.checked) {
      setCheckedUnassignGroup([...checkedUnassignGroup, data]);
    } else {
      const index = checkedUnassignGroup.findIndex(
        (user: any) => user.id === data.id
      );
      checkedUnassignGroup.splice(index, 1);

      setCheckedUnassignGroup([...checkedUnassignGroup]);
    }
  };

  const getAssingedSkillsToGroupEmployee = async (groupId: string) => {
    setIsLoadingAssign(true);
    const urlParams = {
      skillId: state.skillId,
      groupId: groupId,
    };
    const queryParams = {
      page: 0,
      size: 1000,
      sortColumn: "modifiedAt",
      isDescending: true,
      searchString: searchText,
      skillId: state.skillId,
      groupId: groupId,
    };
    await httpGet(
      updateURLParams(
        OPTIVAL_CONSTANTS.API_URLS.GET_ASSIGNED_USER_GROUP_FOR_SKILL,
        urlParams
      ),
      queryParams
    ).then(
      (response: any) => {
        if (response && response.data) {
          if (response.data.error) {
            handleAlertBar(
              "error",
              response?.data?.message || t("opva.serviceUnavailable")
            );
            setIsLoadingAssign(false);
          } else {
            setAssignedGroupUsers(response.data);
            setDisplayAssignedGroupUsers(response.data.slice(0, assignGroupRowsPerPage));
            setIsLoadingAssign(false);
            handleEmptyPageGroup(response.data, "assignedGroupUser");
          }
        } else {
          handleAlertBar("error", t("opva.serviceUnavailable"));
          setIsLoadingAssign(false);
        }
      },
      (error: any) => {
        setIsLoadingAssign(false);
      }
    );
  };

  useEffect(() => {
    if (!openDialog) {
      setSelectedSkill(null);
      setSelectedSkillValidation(null);
    }
  }, [openDialog]);

  const assignSkillToEmployee = async (id?: any) => {
    const empIds = checkedUnassignGroup?.map((user) => user?.id);
    const requestBody = {
      employeeIds: id ? [id] : empIds,
      skillId: state.skillId,
      validated: checkedUnassignGroup.length === 1 ? checkedUnassignGroup[0]?.validationStatus === 1 ? true : false : selectedSkillValidation?.id === 1 ? true : false,
      skillLevelId: checkedUnassignGroup.length === 1 ? checkedUnassignGroup[0]?.skillLevelId : selectedSkill.id,
    };
    await httpPost(
      OPTIVAL_CONSTANTS.API_URLS.ADD_UNASSIGNED_SKILLS_TO_EMPLOYEE,
      requestBody
    ).then(
      (response: any) => {
        setSelectedSkill(null);
        setSelectedSkillValidation(null);
        setAssignData(undefined);
        if (response && response.status) {
          if (response.status === 200) {
            handleAlertBar("success", t("opva.skillAssignEmpSuccessfullyMsg"));
            if(selectedTab === 'GROUPS') {
              setCheckedUnassignGroup([]);
              getUnAssingedSkillsToGroup(groupId);
              getAssingedSkillsToGroupEmployee(groupId);
            } else {
              getAssingedSkillsToEmployee();
            }
            setOpenDialog(false);
          } else {
            handleAlertBar(
              "error",
              response?.data?.message || t("opva.serviceUnavailable")
            );
          }
        } else {
          handleAlertBar("error", t("opva.serviceUnavailable"));
        }
      },
      (error: any) => {}
    );
  };

  const removeSkillFromEmployee = async (id: number) => {
    const requestBody = {
      employeeIds: [id],
      skillId: state.skillId,
      //skillId: 23,
    };
    httpDelete(
      OPTIVAL_CONSTANTS.API_URLS.REMOVE_SKILL_FROM_EMPLOYEE,
      requestBody
    ).then(
      (response) => {
        if (response && response.data && response.data.error) {
          handleAlertBar("error", t("opva.serviceUnavailable"));
        } else {
          handleAlertBar("success", t("opva.skillRemovedFromEmpSucceddfully"));
          if (selectedTab === 'GROUPS') {
            getAssingedSkillsToGroupEmployee(groupId);
            getUnAssingedSkillsToGroup(groupId);
          } else {
            getAssingedSkillsToEmployee();

          }
        }
      },
      (error) => {}
    );
  };

  const handleTabChange = (_event: any, newValue: any) => {
    setSelectedTab(newValue);
  };

  const handleRemoveSkillFromEmployee = (data: EmployeeWithSkill) => {
    removeSkillFromEmployee(data.employee.id);
  };
  const getSkillsLevels = async () => {
    httpGet(OPTIVAL_CONSTANTS.API_URLS.GET_SKILLS_LEVELS).then(
      (response) => {
        if (response && response.data && response.data.error) {
          handleAlertBar("error", response.data.message);
        } else {
          setSkillsLevel(response.data);
        }
      },
      (error) => {
        handleAlertBar("error", error.message || t("opva.serviceUnavailable"));
      }
    );
  };

  const handleSkillChange = (event: any) => {
    const skill = skillsLevel.find(
      (skill: any) => skill?.id === parseInt(event.target.value, 10)
    );
    setSelectedSkill(skill);
  };

  const handleSkillValidationChange = (event: any) => {
    const skill = skillsValidation.find(
      (skill: any) => skill?.id === parseInt(event.target.value, 10)
    );
    setSelectedSkillValidation(skill);
  };

  const assignSkills = () => {
    setOpenDialog(true);
  };

  const assignSkillsToGroup = () => {
    if (checkedUnassignGroup?.length === 1) {
      assignSkillToEmployee()
    } else {
      setOpenDialog(true);
    }
  }

  useMemo(() => {
    const propertyType =
      assignSort.orderBy === "employeeId" ? "number" : "string";
    const sortedList = tableSorting(
      assignedUsers,
      assignSort.order,
      assignSort.orderBy,
      propertyType
    );
    const UnassignGroupSortedList = tableSorting(
      unAssignedGroupUsers,
      assignSort.order,
      assignSort.orderBy,
      propertyType
    );
    setUnAssignedGroupUsers(UnassignGroupSortedList);
    setAssignedUsers(sortedList);
    setDisplayAssignedUsers(
      sortedList.slice(
        assignPage * assignRowsPerPage,
        assignPage * assignRowsPerPage + assignRowsPerPage
      )
    );
    setDisplayUnAssignedGroupUsers(UnassignGroupSortedList.slice(
      unAssignpage * unAssignGroupRowsPerPage,
      unAssignpage * unAssignGroupRowsPerPage + unAssignGroupRowsPerPage
    ))
  }, [assignSort, assignPage, unAssignpage, assignedUsers, unAssignedGroupUsers]);

  const handleAssignUser = (value: any) => {
    setAssignData(value);
  };

  useEffect(() => {
    let timeOutId: number | undefined = undefined;
    if (searchText.length >= 3) {
      timeOutId = window.setTimeout(() => {
        if (selectedTab === "GROUPS") {
          getAssingedSkillsToGroupEmployee(groupId);
        } else {
          getAssingedSkillsToEmployee();
        }
      }, 1000);
    } else if (searchText.length === 0) {
      timeOutId = window.setTimeout(() => {
        queryParams.searchString = "";
        if (selectedTab === "GROUPS") {
          getAssingedSkillsToGroupEmployee(groupId);
        } else {
          getAssingedSkillsToEmployee();
        }
      }, 1000);
    }
    getSkillsLevels();
    return () => {
      window.clearTimeout(timeOutId);
      updateValidateLessMore(true);
    };
  }, [searchText]);

  useEffect(() => {
    if(selectedTab === 'GROUPS') {
      getGroups();
      setUnAssignedGroupUsers([]);
      setAssignedGroupUsers([]);
      setCheckedUnassignGroup([]);
    }

  }, [selectedTab]);

  useEffect(()=> {
    if (state && state.tabValue) {
      setSelectedTab(state.tabValue);
    }
  }, [state.tabValue])

  return (
    <div className="assign-skillz-container">
      <div className="bg-light-blue pt-2 mb-3">
        <div className="px-4">
          <Breadcrumb
            pathList={[
              { name: t("opva.skillz"), path: "skillz" },
              { name: t("opva.skillsManagement"), path: "skillz", isLink: true },
              { name: t("opva.assignSkill"), path: "assign-skill" },
            ]}
          />
          <Grid container alignItems="center" className="pt-2 pb-4">
            <Grid item xs md lg={6} className="d-flex align-items-center">
              <Link
                component="button"
                title={t("opva.backToSkill")}
                className="me-2"
                onClick={backToSkillz}
              >
                <KeyboardArrowLeftIcon fontSize="large" />
              </Link>
              <Typography variant="h4" className="mb-0">
                {t("opva.assign")}&nbsp;[{state.skillName}]
              </Typography>
            </Grid>
            <Grid
              item
              xs
              md
              lg={6}
              className="d-flex align-items-center justify-content-end"
            >
              <Input
                id="search"
                type="text"
                placeholder={t("opva.searchByName")}
                value={searchText}
                startAdornment={
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                }
                endAdornment={
                  searchText && (
                    <InputAdornment position="end">
                      <Link component="button" title={t("opva.clear")}>
                        <CloseIcon
                          fontSize="small"
                          onClick={() => setSearchText("")}
                        />
                      </Link>
                    </InputAdornment>
                  )
                }
                size="small"
                sx={{ paddingLeft: "10px" }}
                onChange={(e) => setSearchText(e.target.value)}
                onKeyDown={handleSearchKeyEnter}
              />
            </Grid>
          </Grid>
        </div>
        <Box
          sx={{ width: "100%", typography: "body1" }}
          className="bg-white px-2"
        >
          <Tabs
            value={selectedTab}
            onChange={handleTabChange}
            indicatorColor="primary"
            textColor="primary"
          >
            <Tab label={t("opva.user")} value={'USER'}/>
            <Tab label={t("opva.groups")} value={'GROUPS'} />
          </Tabs>
        </Box>
        {selectedTab === 'USER' && <>
        <Grid container spacing={2} className="bg-white px-4">
          <Grid item xs={12} md={5} p={3}>
            <Grid container item xs={12} className="mt-4 assign-bulk">
              <Grid item xs={12} className="mb-3 mt-4">
                <Typography variant="body1" className="mb-2 mt-2">
                  {t("opva.assignToBulkUsers")}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="subtitle1" sx={{ marginBottom: 3 }}>
                  {t("opva.step1")}: {t("opva.downloadAssignSkillFormat")}
                </Typography>
              </Grid>
              <Grid item>
                <DownloadExcelButton
                  header={excelHeader}
                  options={excelListOptions}
                  secondOptions={validatedExcelListOptions}
                  secondOptionCell={"D"}
                  optionCell={"B"}
                  listLength={10}
                  defaultValues={defaultValues}
                  fileName={"BulkDatatemplate_assign_skills.xlsx"}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                {" "}
                <div className="bulkuser-dividers m-3">
                  <Divider variant="middle" orientation="horizontal" flexItem />
                </div>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Typography variant="bodyMedium" sx={{ marginBottom: 3 }}>
                  {`${t("opva.step2")}: ${t("opva.fillUploadExcel")}`}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <div
                  className="upload-box-container"
                  onDragOver={handleUploadBoxDragOver}
                  onDrop={handleUploadBoxDrop}
                >
                  <input
                    type="file"
                    accept=".xlsx"
                    hidden
                    id="user-file-upload"
                    onChange={handleFileChange}
                  />
                  <div className="d-flex align-self-center mb-2">
                    {!selectedFile && (
                      <label
                        htmlFor="user-file-upload"
                        className="file-upload-icon"
                      >
                        <FileUploadOutlinedIcon color="primary" />
                      </label>
                    )}
                    {selectedFile && (
                      <Chip
                        color="primary"
                        sx={{ minWidth: "auto", maxWidth: "250px" }}
                        label={selectedFile.name}
                        title={selectedFile.name}
                        onDelete={handleRemoveClick}
                      />
                    )}
                  </div>
                  <div className="d-flex align-self-center mb-2">
                    <label htmlFor="user-file-upload">
                      <Link
                        variant="bodyNormal"
                        underline="none"
                        className="me-1"
                      >
                        <b>{t("opva.clickHere")}</b>
                      </Link>
                      <Typography variant="bodyNormal">
                        {t("opva.uploadOrDropExcelFile")}
                      </Typography>
                    </label>
                  </div>
                </div>
                <div style={{ marginLeft: "25px" }}>
                  {errorMsg && (
                    <Typography variant="body1" color="error">
                      {`Error: ${errorMsg}`}
                    </Typography>
                  )}
                </div>
              </Grid>
              <Grid item xs={12} md={6} className="mb-4">
                <Button
                  size="large"
                  variant="contained"
                  sx={{ color: "#FFFFFFCC", textTransform: "none" }}
                  onClick={handleBulkUser}
                  disabled={!selectedFile}
                >
                  {t("opva.confirmUpload")}
                </Button>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md lg={1} mt={1}>
            <div className="Dividers">
              <Divider variant="middle" />
            </div>
          </Grid>
          <Grid item xs={12} md={5} mt={1}>
            <Grid container item xs={12} className="mt-4 assign-bulk">
              <Grid item xs={12} className="mb-3 mt-4">
                <Typography variant="body1" className="mb-2 mt-2">
                  {t("opva.addUsersManually")}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="subtitle1" sx={{ marginBottom: 3 }}>
                  {t("opva.assignUserManuallyEmail")}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <div className="assign-workflow-container">
                  <div className="d-flex mb-3">
                    <Autocomplete
                      id="search-by-user"
                      className="me-5 w-50"
                      options={unAssignedUsers ? unAssignedUsers : []}
                      autoComplete
                      loadingText={t("opva.userSearching")}
                      noOptionsText={
                        !unAssignedUsers ? (
                          <Typography variant="labelNormal">
                            {t("opva.type2Letters")}
                          </Typography>
                        ) : (
                          <Typography variant="labelNormal">
                            {t("opva.noUsersFound")}
                          </Typography>
                        )
                      }
                      getOptionLabel={(option) => option?.mail}
                      renderOption={(props, option: SkillsToEmployee) => (
                        <li {...props} key={option?.id} value={option.mail}>
                          <Typography variant="labelLarge">
                            {option?.mail} | {option?.firstName}
                          </Typography>
                        </li>
                      )}
                      value={null}
                      onChange={(
                        event: any,
                        value: SkillsToEmployee | null
                      ) => {
                        if (value && typeof value === "object") {
                          handleAssignUser(value);
                        }
                      }}
                      onInputChange={(event: any, newInputValue: string) => {
                        getUnAssignedSkillsToEmployee(newInputValue);
                      }}
                      renderInput={(params: any) => (
                        <TextField
                          label={t("opva.searchByEmailName")}
                          {...params}
                          size="small"
                          variant="outlined"
                          placeholder={t("opva.searchByEmailName")}
                          className="search-name-text"
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <InputAdornment position="end">
                                <SearchIcon
                                  fontSize="small"
                                  color="inherit"
                                  className="me-2"
                                />
                              </InputAdornment>
                            ),
                          }}
                        />
                      )}
                    />
                    {assignData && (
                      <Chip
                        key={assignData?.id}
                        label={assignData?.mail}
                        color="primary"
                        onDelete={handleRemoveAssignUser}
                        sx={{ borderRadius: "8px" }}
                      />
                    )}
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} className="mb-4">
                <Typography variant="body1" className="m-1">
                  {t("opva.selectSkillLevel")}
                </Typography>
                <FormControl component="fieldset">
                  <RadioGroup
                    className="ms-1"
                    row
                    aria-labelledby="row-radio-buttons-group-label"
                    name="skill"
                    value={selectedSkill?.id || ""}
                    onChange={handleSkillChange}
                  >
                    {skillsLevel.map((skill: any) => (
                      <FormControlLabel
                        key={skill.id}
                        value={skill.id}
                        control={
                          <Radio
                            sx={{
                              color: "#0084F4",
                            }}
                            checkedIcon={<CheckCircleIcon />}
                          />
                        }
                        label={t(`opva.${skill.name.toLowerCase()}`)}
                      />
                    ))}
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item xs={12} className="mb-4">
                <Typography variant="body1" className="m-1">
                  {t("opva.selectValidation")}
                </Typography>
                <FormControl component="fieldset">
                  <RadioGroup
                    className="ms-1"
                    row
                    aria-labelledby="row-radio-buttons-group-label"
                    name="skill"
                    value={selectedSkillValidation?.id || ""}
                    onChange={handleSkillValidationChange}
                  >
                    {skillsValidation.map((skill: any) => (
                      <FormControlLabel
                        key={skill.id}
                        value={skill.id}
                        control={
                          <Radio
                            sx={{
                              color: "#0084F4",
                            }}
                            checkedIcon={<CheckCircleIcon />}
                          />
                        }
                        label={t(`opva.${skill.name.toLowerCase()}`)}
                      />
                    ))}
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={6} className="mb-4">
                <Button
                  size="large"
                  variant="contained"
                  sx={{ color: "#FFFFFFCC", textTransform: "none" }}
                  onClick={assignSkills}
                  disabled={
                    !assignData ||
                    selectedSkill === null ||
                    selectedSkillValidation === null
                  }
                >
                  {t("opva.assignSkill")}
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Box className="assignedusers-container bg-white px-4">
          <Typography variant="subtitle1" m={1}>
            {t("opva.assignedUser")}
          </Typography>

          <TableContainer>
            <Table
              stickyHeader
              sx={{ width: "100%" }}
              size="medium"
              aria-label="AssignSkillz table"
            >
              <TableHead>
                <TableRow>
                  <TableCell
                    component="th"
                    scope="row"
                    padding="checkbox"
                  ></TableCell>
                  {getAssignWorkflowHeaders().map((headCell: TableHeadCell) => (
                    <TableCell
                      key={headCell.id}
                      sortDirection={
                        assignSort.orderBy === headCell.id
                          ? assignSort.order
                          : false
                      }
                      align={headCell.position}
                      sx={{
                        width: headCell.width + "%",
                      }}
                    >
                      {headCell?.sorting ? (
                        <TableSortLabel
                          active={
                            assignSort.orderBy === headCell.sortingProperty
                          }
                          direction={
                            assignSort.orderBy === headCell.sortingProperty
                              ? assignSort.order
                              : "desc"
                          }
                          onClick={(event) =>
                            handleSorting(
                              headCell.sortingProperty,
                              "assignTable"
                            )
                          }
                        >
                          {headCell.label}
                          {assignSort.orderBy === headCell.id ? (
                            <Box component="span" sx={visuallyHidden}>
                              {assignSort.order === "desc"
                                ? "sorted descending"
                                : "sorted ascending"}
                            </Box>
                          ) : null}
                        </TableSortLabel>
                      ) : (
                        headCell.label
                      )}
                      {/* <Typography style={{ fontWeight: "500" }}>
                    {column.label}
                  </Typography> */}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              {isLoadingAssign ? (
                <TableLoading column={getAssignWorkflowHeaders().length + 1} />
              ) : (
                <TableBody>
                  {assignedUsers && assignedUsers.length ? (
                    displayAssignedUsers.map((data: any) => (
                      <TableRow key={data.id}>
                        <TableCell
                          component="th"
                          scope="row"
                          padding="checkbox"
                        >
                          <img
                            src="images/User-Thumb.svg"
                            alt="User Icon"
                            width={40}
                            height={40}
                          />
                        </TableCell>
                        <TableCell>
                          {data?.employee?.firstName} {data?.employee?.lastName}
                        </TableCell>

                        <TableCell>{data?.employee?.employeeId}</TableCell>
                        <TableCell>{data?.employee?.mail}</TableCell>
                        <TableCell>
                          {data?.employee?.assignedRoles.length
                            ? data?.employee?.assignedRoles
                                .map((roles: any) => roles.name)
                                .join(", ")
                            : ""}
                        </TableCell>
                        <TableCell>{data?.skillLevelName}</TableCell>
                        <TableCell>
                          {data?.validationStatus
                            ? t("opva.validated")
                            : t("opva.notvalidated")}
                        </TableCell>
                        <TableCell align="center">
                          <DeleteOutlineIcon
                            color="error"
                            onClick={() => handleRemoveSkillFromEmployee(data)}
                          />
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell align="center" colSpan={7}>
                        {searchText
                          ? t("opva.searchAsssignDataNotAvailable")
                          : t("opva.noDataAvailable")}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              )}
            </Table>
            <div className="d-flex align-items-center justify-content-end">
              <TablePagination
                component="div"
                className="pagination-container mb-2"
                rowsPerPageOptions={[5, 10, 25]}
                count={assignedUsers.length}
                page={assignPage}
                onPageChange={handleChangePageForAssigned}
                rowsPerPage={assignRowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPageForAssigned}
              />
            </div>
          </TableContainer>
        </Box>
        </>}

        {selectedTab === 'GROUPS' && 
        <>        
        <Grid container spacing={2} className="bg-white" p={3}>
        <Grid item xs={12} m={1}>
                <Typography variant="subtitle1">
                  {t("opva.assignSkillsToGroup")}
                </Typography>
                <Typography variant="h6">
                  {t("opva.addedUserFromGroupNote")}
                </Typography>
            </Grid>
                        <Grid item m={1}  className="d-flex flex-column">
                          <FormControl variant="standard" sx={{minWidth: 180 }}>
        <InputLabel id="demo-simple-select-standard-label">{t("opva.groupName")}</InputLabel>
        <Select
          labelId="demo-simple-select-standard-label"
          id="demo-simple-select-standard"
          value={groupId}
          onChange={handleGroupChange}
          label={t("opva.groupName")}
        >
          {groupList?.map((group: any)=> 
            (<MenuItem value={group.id}>{group?.name}</MenuItem>)
          )}
        </Select>
        </FormControl>
                        </Grid>
        <Grid item lg={12}>
        <Box>
          <Typography variant="h6" m={1}>
            {t("opva.addedUserFromGroup")}
          </Typography>

          <TableContainer>
            <Table
              stickyHeader
              size="medium"
              aria-label="AssignSkillz table"
            >
              <TableHead>
                <TableRow>
                  <TableCell size="small" padding="checkbox">
                                  <Checkbox
                                        checked={allUnassignGroupUserChecked()}
                                        onChange={(e) => handleAllCheckBoxForUnassignGroupUser(e)}
                                    />
                                  </TableCell>
                  {getUnAssignWorkflowHeaders().map((headCell: TableHeadCell) => (
                    <TableCell
                      key={headCell.id}
                      sortDirection={
                        assignSort.orderBy === headCell.id
                          ? assignSort.order
                          : false
                      }
                      align={headCell.position}
                      sx={{
                        width: headCell.width + "%",
                      }}
                    >
                      {headCell?.sorting ? (
                        <TableSortLabel
                          active={
                            assignSort.orderBy === headCell.sortingProperty
                          }
                          direction={
                            assignSort.orderBy === headCell.sortingProperty
                              ? assignSort.order
                              : "desc"
                          }
                          onClick={(event) =>
                            handleSorting(
                              headCell.sortingProperty,
                              "assignTable"
                            )
                          }
                        >
                          {headCell.label}
                          {assignSort.orderBy === headCell.id ? (
                            <Box component="span" sx={visuallyHidden}>
                              {assignSort.order === "desc"
                                ? "sorted descending"
                                : "sorted ascending"}
                            </Box>
                          ) : null}
                        </TableSortLabel>
                      ) : (
                        headCell.label
                      )}
                      {/* <Typography style={{ fontWeight: "500" }}>
                    {column.label}
                  </Typography> */}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              {isLoadingUnAssign ? (
                <TableLoading column={getUnAssignWorkflowHeaders().length + 1} />
              ) : (
                <TableBody>
                  {unAssignedGroupUsers && unAssignedGroupUsers.length ? (
                    displayUnAssignedGroupUsers.map((data: any, index: number) => (
                      <TableRow key={data.id}>
                        <TableCell size="small" padding="checkbox">
                          <Checkbox
                            checked={checkedUnassignedGroupUser(data)}
                            onChange={(e) => handleCheckBoxForGroupUser(e, data)}
                          />
                        </TableCell>
                        <TableCell>
                          {data?.firstName}
                        </TableCell>

                        <TableCell>{data?.employeeId}</TableCell>
                        <TableCell>{data?.mail}</TableCell>
                        <TableCell>
                          {data?.assignedRoles.length
                            ? data?.assignedRoles
                                .map((roles: any) => roles.name)
                                .join(", ")
                            : ""}
                        </TableCell>
                        <TableCell><Select
          labelId="demo-simple-select-standard-label"
          id="demo-simple-select-standard"
          value={data?.skillLevelId}
          onChange={(e) => handleUnassignFieldChange(index,'skillLevelId',e.target.value)}
        >
          {skillsLevel?.map((level: any)=> 
            (<MenuItem value={level.id}>{level?.name}</MenuItem>)
          )}
        </Select></TableCell>

                        <TableCell>
                            <Select
          labelId="demo-simple-select-standard-label"
          id="demo-simple-select-standard"
          value={data?.validationStatus}
          onChange={(e) => handleUnassignFieldChange(index,'validationStatus', e.target.value)}
        >
          {skillsValidation?.map((level: any)=> 
            (<MenuItem value={level.id}>{level?.label}</MenuItem>)
          )}
        </Select>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell align="center" colSpan={7}>
                        {searchText
                          ? t("opva.searchAsssignDataNotAvailable")
                          : t("opva.noDataAvailable")}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              )}
            </Table>
            <div className="d-flex align-items-center justify-content-end">
              <TablePagination
                component="div"
                className="pagination-container mb-2"
                rowsPerPageOptions={[5, 10, 25]}
                count={unAssignedGroupUsers.length}
                page={unAssignpage}
                onPageChange={handleChangePageForUnAssignedGroup}
                rowsPerPage={unAssignGroupRowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPageForUnAssignedGroup}
              />
            </div>
          </TableContainer>
        </Box>

        </Grid>
        <Grid item xs={12} md={6} className="mb-4">
                <Button
                  size="large"
                  variant="contained"
                  sx={{ color: "#FFFFFFCC", textTransform: "none" }}
                  onClick={() => assignSkillsToGroup()}
                  disabled={
                    checkedUnassignGroup.length === 0
                  }
                >
                  {t("opva.assignSkill")}
                </Button>
              </Grid>
        
      </Grid>
        <Box className="assignedusers-container bg-white px-4">
          <Typography variant="subtitle1" m={1}>
            {t("opva.assignedUser")}
          </Typography>

          <TableContainer>
            <Table
              stickyHeader
              sx={{ width: "100%" }}
              size="medium"
              aria-label="AssignSkillz table"
            >
              <TableHead>
                <TableRow>
                  <TableCell
                    component="th"
                    scope="row"
                    padding="checkbox"
                  ></TableCell>
                  {getAssignWorkflowHeaders().map((headCell: TableHeadCell) => (
                    <TableCell
                      key={headCell.id}
                      sortDirection={
                        assignSort.orderBy === headCell.id
                          ? assignSort.order
                          : false
                      }
                      align={headCell.position}
                      sx={{
                        width: headCell.width + "%",
                      }}
                    >
                      {headCell?.sorting ? (
                        <TableSortLabel
                          active={
                            assignSort.orderBy === headCell.sortingProperty
                          }
                          direction={
                            assignSort.orderBy === headCell.sortingProperty
                              ? assignSort.order
                              : "desc"
                          }
                          onClick={(event) =>
                            handleSorting(
                              headCell.sortingProperty,
                              "assignTable"
                            )
                          }
                        >
                          {headCell.label}
                          {assignSort.orderBy === headCell.id ? (
                            <Box component="span" sx={visuallyHidden}>
                              {assignSort.order === "desc"
                                ? "sorted descending"
                                : "sorted ascending"}
                            </Box>
                          ) : null}
                        </TableSortLabel>
                      ) : (
                        headCell.label
                      )}
                      {/* <Typography style={{ fontWeight: "500" }}>
                    {column.label}
                  </Typography> */}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              {isLoadingAssign ? (
                <TableLoading column={getAssignWorkflowHeaders().length + 1} />
              ) : (
                <TableBody>
                  {assignedGroupUsers && assignedGroupUsers.length ? (
                    displayAssignedGroupUsers.map((data: any) => (
                      <TableRow key={data.id}>
                        <TableCell
                          component="th"
                          scope="row"
                          padding="checkbox"
                        >
                          <img
                            src="images/User-Thumb.svg"
                            alt="User Icon"
                            width={40}
                            height={40}
                          />
                        </TableCell>
                        <TableCell>
                          {data?.employee?.firstName}
                        </TableCell>

                        <TableCell>{data?.employee?.employeeId}</TableCell>
                        <TableCell>{data?.employee?.mail}</TableCell>
                        <TableCell>
                          {data?.employee?.assignedRoles.length
                            ? data?.employee?.assignedRoles
                                .map((roles: any) => roles.name)
                                .join(", ")
                            : ""}
                        </TableCell>
                        <TableCell>{data?.skillLevelName}</TableCell>
                        <TableCell>
                          {data?.validationStatus
                            ? t("opva.validated")
                            : t("opva.notvalidated")}
                        </TableCell>
                        <TableCell align="center">
                          <DeleteOutlineIcon
                            color="error"
                            onClick={() => handleRemoveSkillFromEmployee(data)}
                          />
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell align="center" colSpan={7}>
                        {searchText
                          ? t("opva.searchAsssignDataNotAvailable")
                          : t("opva.noDataAvailable")}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              )}
            </Table>
            <div className="d-flex align-items-center justify-content-end">
              <TablePagination
                component="div"
                className="pagination-container mb-2"
                rowsPerPageOptions={[5, 10, 25]}
                count={assignedGroupUsers.length}
                page={assignGroupPage}
                onPageChange={handleChangePageForAssignedGroup}
                rowsPerPage={assignGroupRowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPageForAssignedGroup}
              />
            </div>
          </TableContainer>
        </Box></>}
      </div>
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
        <DialogContent>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography variant="h6">{t("opva.assignToUser")}</Typography>
            <IconButton aria-label="close" onClick={() => setOpenDialog(false)}>
              <CloseIcon />
            </IconButton>
          </div>
          <Typography variant="body1" className="m-1">
            {t("opva.selectedUser")}
          </Typography>
          {assignData && selectedTab === 'USER' && (
            <div>
              <Chip
                key={assignData?.id}
                label={assignData?.mail}
                color="primary"
                onDelete={handleRemoveAssignUser}
                style={{ margin: "4px" }}
              />
            </div>
          )}
          {checkedUnassignGroup?.length > 0 && selectedTab === 'GROUPS' && 
          checkedUnassignGroup?.map((user)=>(
            <div>
              <Chip
                key={user?.id}
                label={user?.mail}
                color="primary"
                onDelete={() => handleRemoveUnAssignUser(user?.id)}
                style={{ margin: "4px" }}
              />
            </div>

          ))}

          <div>
            <Typography variant="body1" className="m-1">
              {t("opva.selectSkillLevel")}
            </Typography>
            <FormControl component="fieldset">
              <RadioGroup
                className="ms-1"
                row
                aria-labelledby="row-radio-buttons-group-label"
                name="skill"
                value={selectedSkill?.id || ""}
                onChange={handleSkillChange}
              >
                {skillsLevel.map((skill: any) => (
                  <FormControlLabel
                    key={skill.id}
                    value={skill.id}
                    control={
                      <Radio
                        sx={{
                          color: "#0084F4",
                        }}
                        checkedIcon={<CheckCircleIcon />}
                      />
                    }
                    label={t(`opva.${skill.name.toLowerCase()}`)}
                  />
                ))}
              </RadioGroup>
            </FormControl>
          </div>
          <div>
            <Typography variant="body1" className="m-1">
              {t("opva.selectValidation")}
            </Typography>
            <FormControl component="fieldset">
              <RadioGroup
                className="ms-1"
                row
                aria-labelledby="row-radio-buttons-group-label"
                name="skill"
                value={selectedSkillValidation?.id || ""}
                onChange={handleSkillValidationChange}
              >
                {skillsValidation.map((skill: any) => (
                  <FormControlLabel
                    key={skill.id}
                    value={skill.id}
                    control={
                      <Radio
                        sx={{
                          color: "#0084F4",
                        }}
                        checkedIcon={<CheckCircleIcon />}
                      />
                    }
                    label={t(`opva.${skill.name.toLowerCase()}`)}
                  />
                ))}
              </RadioGroup>
            </FormControl>
          </div>
        </DialogContent>
        <DialogActions className="dialog-btn">
          <Button
            color="primary"
            variant="contained"
            sx={{ textTransform: "none" }}
            onClick={() => assignSkillToEmployee(assignData?.id)}
            disabled={
              (selectedTab === 'GROUPS' ? !checkedUnassignGroup: !assignData) ||
              selectedSkill === null ||
              selectedSkillValidation === null
            }
          >
            {t("opva.save")}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
